// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.img-container[data-v-e4ea0506] {
  width: 100%;
}
img[data-v-e4ea0506] {
  display: block;
  height: auto;
}
.pequena[data-v-e4ea0506] {
  width: 15% !important;
}
.media[data-v-e4ea0506] {
  width: 50% !important;
  -o-object-fit: contain;
     object-fit: contain;
}
.grande[data-v-e4ea0506] {
  width: 100% !important;
  -o-object-fit: contain;
     object-fit: contain;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
